import React from 'react';

function Footer() {
    return <footer>
        Icons by <a target="_blank" href="https://icons8.com" rel="noreferrer">Icons8</a>
    </footer>
}

export default Footer;